module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2QqzeD8l0kEyUKKQO0Yakw-04d65260d74829f294dd74065b2053be.jpg";